import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function NitrogenPlantTable({ data, onEdit }) {
  const columns = [
    {
      title: "Nitrogen Plant Name",
      dataIndex: "nitrogen_plant_name",
      key: "nitrogen_plant_name",
      align: "center",
    },
    {
      title: "Nitrogen Plant Maker",
      dataIndex: "nitrogen_plant_maker",
      key: "nitrogen_plant_maker",
      align: "center",
    },
    {
      title: "Nitrogen Plant Model",
      dataIndex: "nitrogen_plant_model",
      key: "nitrogen_plant_model",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
